import { useMemo } from 'react';
import { Button } from '@cropler/ui-kit';

import styles from './styles.module.scss';

import { DatePicker } from '../../components';
import { useViewport } from '../../hooks';
import { BreakpointMobileUp } from '../../constants/ui';
import { Icon as CroplerIcon } from '@cropler/ui-kit';

const datepickerStyle = {
  borderLeft: 'none',
  borderRight: 'none',
  borderRadius: 0,
  backgroundColor: '#fff',
};

const datepickerDarkStyle = {
  borderLeft: 'none',
  borderRight: 'none',
  borderTop: 'none',
  borderBottom: 'none',
  borderRadius: 0,
  backgroundColor: 'rgba(27, 31, 38, .8)',
};

const FilterDate = ({ allDates, selectedDate, isDarkTheme = false, selectDate }) => {
  const { widthViewport } = useViewport();
  const index = useMemo(() => allDates.indexOf(selectedDate), [selectedDate, allDates]);

  const selectPrevDate = () => {
    const prevDate = allDates[index - 1];

    if (index - 1 >= 0) {
      selectDate(prevDate);
    }
  };

  const selectNextDate = () => {
    const nextDate = allDates[index + 1];

    if (index + 1 < allDates.length) {
      selectDate(nextDate);
    }
  };

  return (
    <div className={`${styles.dateContainer} ${isDarkTheme ? styles.dateContainerDark : ''}`}>
      <Button
        className={`${styles.dateButton} ${styles.dateButtonLeft}`}
        type={isDarkTheme ? 'primary' : 'secondary'}
        onClick={selectPrevDate}
        disabled={index === 0}
        icon={<CroplerIcon name="left" />}
        size={widthViewport < BreakpointMobileUp ? 'large' : null}
      ></Button>
      <DatePicker
        selectedDate={selectedDate}
        selectDate={selectDate}
        dates={allDates}
        rootClassName={'custom-date-picker custom-date-picker--filter'}
        style={isDarkTheme ? datepickerDarkStyle : datepickerStyle}
        size={widthViewport < BreakpointMobileUp ? 'large' : null}
      />
      <Button
        className={`${styles.dateButton} ${styles.dateButtonRight}`}
        type={isDarkTheme ? 'primary' : 'secondary'}
        onClick={selectNextDate}
        disabled={index === allDates.length - 1}
        icon={<CroplerIcon name="left" />}
        size={widthViewport < BreakpointMobileUp ? 'large' : null}
      ></Button>
    </div>
  );
};

export default FilterDate;
